export const applicationConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL,
  CAPTCHA_SITE_KEY: process.env.REACT_APP_CAPTCHA_SITE_KEY,
  STRIPE_PROMISE_KEY: process.env.REACT_APP_STRIPE_API_KEY,
  UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL,
  footerText: `© ${new Date().getFullYear()} All rights reserved, Pharmaceutical & BioScience Society International.`,
};
